import { render } from "./PaymentConfirmation.vue?vue&type=template&id=26270f92&scoped=true&lang=pug"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=ts"

import "./PaymentConfirmation.vue?vue&type=style&index=0&id=26270f92&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-26270f92"

export default script